import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Koop 1, krijg 1',
  [OFFER_TYPE.FREE_ITEM]: 'Gratis item',
  [OFFER_TYPE.AMOUNT_OFF]: 'Bedrag korting',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Percentage korting',
};
